// 캐릭터 목록
NP.Character = (function( $, body ) {
	var character = {},
		cache;

	body.on( 'click', '.selectSetChar .js_selector label', function() {
		NP.Character.set( $( this ).parent().index() );
	});
	
	character.setMajorCharacter = function(){
		//if(  NP.dt.page === 'characterguestbook' || NP.dt.page === 'groupguestbook' || ( NP.dt.st === 'aion' && NP.dt.page === 'group' ) ){	
		if(  NP.dt.page === 'characterguestbook' || NP.dt.page === 'groupguestbook' || NP.dt.page === 'group' ){		
			NP.dt.vCharId = NP.dt.vCharId || '';
			NP.dt.vServerId = NP.dt.vServerId || '';
				
			selectedBox( '#writeShort .wrap_option', NP.dt.vCharId, NP.dt.vServerId, true );
			NP.Character.set( $( '#writeShort .wrap_option .selectSetChar' ).find( ':radio:checked' ).attr('seq') - 1 );
		}
	};
	
	character.setMyCharacter = function(){

		//if( NP.dt.o != NP.dt.v ) return;
		
		if( NP.charInfo.wrtChrtId && NP.charInfo.wrtSvrId ){
			selectedBox( '.article .wrap_form', NP.charInfo.wrtChrtId, NP.charInfo.wrtSvrId, true );
			NP.Character.set( $( '.article .wrap_form' ).find( ':radio:checked' ).attr('seq') );
		}

	};
	
	character.setLegionCharacter = function(){
		selectedBox( '#writeShort .wrap_option', '', '', true, true );
		NP.Character.set( $( '#writeShort .wrap_option .selectSetChar' ).find( ':radio:checked' ).attr('seq') );
	};
	
	character.hideSelectOpen = function(){
		
		if( NP.dt.page === 'group' || NP.dt.page === 'groupguestbook' || NP.dt.page === 'characterguestbook' ){
			
			var selectSetOpen = $( '.selectSetOpen:not(.hidden)' );

			if( !selectSetOpen.length ) return;
			
			selectSetOpen.hide();
			
			var chkInput = selectSetOpen.find( 'input[value="friend"]' );
			var chkLabel = chkInput.parent();
			chkInput.attr( 'checked', 'checked' );
			selectSetOpen.removeClass( 'checked' );
			chkLabel.addClass( 'checked' );
			
			selectSetOpen.addClass( 'hidden' );
		}
	};

	
	character.setSelectOpen = function(){
		var writeWrap = $( '#writeShort' ),
			options = writeWrap.find( '.wrap_option' );
		if( options.find( '.selectSetOpen' ).length ) return;
		
		if( NP.dt.st === 'aion' ){
			options.append(NP.tmpl.selectSetOpen);
			selectbox( '.wrap_option' );
		}

	};
	
	character.setSelectChar = function( html ){
		
		var writeWrap = $( '#writeShort' ),
		options = writeWrap.find( '.wrap_option' );
		
		if( options.find( '.selectSetChar' ).length ) return;
		
		options.append( html );
		
		selectbox( '.wrap_option' );
	};
	
	character.setSelectSetChar = function( data ){
		if( !data ) return '';
		
		if ( !data.characters ) {
			return '';
		}
		
		//이미 존재할 경우 제거
		if( $('.wrap_editorShort .js_select.selectSetChar' ).length )
			$('.wrap_editorShort .js_select.selectSetChar' ).remove();
		
		var charList = data.characters, 
			characters = {
				aion: ( charList.AION )? charList.AION: [],
				bns: ( charList.BNS )? charList.BNS: [],
				sort: ['bns', 'aion']
			};

		if( NP.dt.st === 'aion' ) characters.sort.reverse();
		
		//아이온 캐릭터 방명록, 그룹 방명록, 그룹
		if(  NP.dt.st === 'aion' && ( NP.dt.page === 'characterguestbook' || NP.dt.page === 'groupguestbook' || NP.dt.page === 'group' ) ){
			characters.sort = ['aion'];
		};
		
		//블소 캐릭터 방명록
		if(  NP.dt.st === 'bns' && ( NP.dt.page === 'characterguestbook' ) ){
			characters.sort = ['bns'];
		};
		
		var html = '<div class="js_select selectSetChar"><em class="js_selected">선택 안함</em><div class="js_selector selectTy1_selector" style="display:none"><ul>',
			i = 0;
			
			
		
		for ( var k = 0, l = characters.sort.length; l > k; k++ ){
			var sort = characters.sort[ k ],
				chars = characters[ sort ],
				j = 0;
			
			for ( ; chars[ j ]; j += 1 ) {
				html += '<li class="' + sort + '"><label><input type="radio" name="chrtInfo" data-location="' + chars[ j ].location + '" data-writerGamename="' + sort + '" id="selCharacter' + ( i + 1 )+ '" seq="'+  ( (NP.dt.page != 'group')? i + 1: i ) +'" data-chrtid="' + chars[ j ].characterId + '" data-chrtnm="' + chars[ j ].characterName + '" data-svrid="' + chars[ j ].serverId + '" /><span class="charname">[' + chars[ j ].characterName + ']</span> ' + chars[ j ].serverName + '</label></li>';
				i++;
			}
		}

		if( NP.dt.page != 'characterguestbook' )
			html += '<li><label><input type="radio" name="b" value="0">선택 안함</label></li>';
		
		html += '</ul></div></div>';

		return html;
	};
	
	character.setUI = function( data ) {
		if( !data ) return '';
		if ( !data.characters ) {
			return '';
		}

		var charList = data.characters, 
		characters = {
			aion: ( charList.AION )? charList.AION: [],
			bns: ( charList.BNS )? charList.BNS: [],
			sort: ['bns', 'aion']
		};

		if( NP.dt.st === 'aion' ) characters.sort.reverse();		
		
		//아이온 캐릭터 방명록, 그룹 방명록, 그룹
		if(  NP.dt.st === 'aion' && ( NP.dt.page === 'characterguestbook' || NP.dt.page === 'groupguestbook' || NP.dt.page === 'group' ) ){
			characters.sort = ['aion'];
		};		
		
		//블소 캐릭터 방명록
		if(  NP.dt.st === 'bns' && ( NP.dt.page === 'characterguestbook' ) ){
			characters.sort = ['bns'];
		};
			
		var html = '<div class="js_select selectSetChar"><em class="js_selected">선택 안함</em><div class="js_selector selectTy1_selector" style="display:none"><ul>',
		i = 0;
	
	
		for ( var k = 0, l = characters.sort.length; l > k; k++ ){
			var sort = characters.sort[ k ],
				chars = characters[ sort ],
				j = 0;
			
			for ( ; chars[ j ]; j += 1 ) {
				html += '<li class="' + sort + '"><label><input type="radio" name="char" data-location="' + chars[ j ].location + '" data-writerGamename="' + sort + '" value="' + ( i + 1 )+ '" seq="'+ ( (NP.dt.page != 'group')? i + 1: i ) +'" data-chrtid="' + chars[ j ].characterId + '" data-chrtnm="' + chars[ j ].characterName + '" data-svrid="' + chars[ j ].serverId + '" /><span class="charname">[' + chars[ j ].characterName + ']</span> ' + chars[ j ].serverName + '</label></li>';
				i++;
			}
		}	

		if( NP.dt.page != 'characterguestbook' )
			html += '<li><label><input type="radio" name="char" value="0">선택 안함</label></li>';		

		html += '</ul></div></div>';
		
		return html;
	};
	
	character.set = function( index ) {
		if ( typeof index == 'undefined' ) {
			if ( cache ) {
				index = cache;
			} else {
				index = 0;
			}
		}

		$( '.selectSetChar' ).each(function() {
			var el = $( this );

			el.find( 'label' ).removeClass( 'checked' ).eq( index ).addClass( 'checked' );
			//el.find( '.js_selected' ).text( el.find( 'label' ).removeClass( 'checked' ).eq( index ).addClass( 'checked' ).text() );
			el.find( '.js_selected' ).text( el.find( 'label' ).removeClass( 'checked' ).eq( index ).addClass( 'checked' ).text() );
			el.find( 'label input' ).eq( index ).attr( 'checked', 'checked' );
			
			//selectbox가 1개일 경우 notSelected class 추가
			if( el.find( '.js_selector ul li' ).length == 1 )
				el.find( '.js_selected' ).addClass( 'notSelected' );
			
		});
		/* options.jsSelect.find('label').removeClass('checked');
			//label에 text가 있으면 jsSelected에 넣어줌
			if(options.chkInput.html()!=null){
				options.chkLabel.addClass('checked');
				options.jsSelected.html( options.chkLabel.html() ).find('input').remove();
			}
			options.jsSelector.hide(); */
		cache = index;
	};

	character.getCache = function() {
		return cache;
	};

	return character;
}( jQuery, NP.body ));

// 캐릭터 목록 가져오기( 로그인 시에만 )
NP.onBeforeGetTimeline.add(function( callbacks ) {
	if ( typeof callbacks !== 'function' ) {
		return;
	}
	
	if ( !NP.dt.v ) { // 비로그인 시
		// 호출한 GUID를 visitor id 로 대입
		//NP.dt.v = NP.Util.getGUID();

		callbacks();

		return;
	}

	jQuery.ajax({
		dataType : 'json',
		url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/my/character.json?trgtId=' + NP.Util.getParam( 'trgtId' ),
		success : function( data ) {
			if ( !data.characters ) {
				callbacks();
				return;
			}
			
			NP.Character.data = data;
			callbacks();
		}
	});
});
